import React, { useEffect, useState } from 'react'
import Header from '../../layout/Header';
import Leftpanel from '../../layout/Leftpanel';
import { getAllIndustryDetailslist } from '../../../../service/BusinessUnit/BusinessUnitService';
import { getIndustryById } from '../../../../service/Department/DepartmentService';
import { getALLGLlist } from "../../../../service/gl/glService";
import { AddAccountingDimensions, listAccountingDimensions, DeleteAccountingDimensions, addEditAccountDimension, getAccountDimensionById } from '../../../../service/AccountingDimensions/AccountingDimensions';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const AccountingDimensions = () => {
  const navigate = useNavigate();
  const [accountingDimensions, setAccountingDimensions] = useState({
    dimension2: '',
    dimension3: '',
    dimension4: '',
    dimension5: '',
    dimension6: '',
  });
  const [accountingDimensionsFieldName, setAccountingDimensionsFieldName] = useState({
    GLFieldName: '',
    Dimension2FieldName: '',
    Dimension3FieldName: '',
    Dimension4FieldName: '',
    Dimension5FieldName: '',
    Dimension6FieldName: ''
  })
  const [glKey, setGlKey] = useState(null);
  const [totalDimantion, setTotalDimantion] = useState(2);
  const _FETCH_GL_KEY = async () => {
    getALLGLlist().then(res => {
      setGlKey({
        text: res?.data?.data?.glList[0]?.value,
        key: res?.data?.data?.glList[0]?.key,
        id: res?.data?.data?.glList[0]?.id
      })
    }).catch(err => {
    //  console.log(err)
    })
  }


  useEffect(() => {
    // _FETCH_BUSINESS_UNIT();
    // _FETCH_ACCOUNTING_DIMENSION();
    _FETCH_GL_KEY();
    // _FETCH_ACCOUTING_DIMENSION_BY_ID();
  }, [])

  const _UPDATE_DIMANTION = async (data) => {
    setTotalDimantion(data);
  }

  const _ADD_GL_KEY = async (e) => {
    e.preventDefault();
    try {
      const data = {
        GLId: glKey.id,
        dimension2: accountingDimensions?.dimension2,
        dimension3: accountingDimensions?.dimension3,
        dimension4: accountingDimensions?.dimension4,
        dimension5: accountingDimensions?.dimension4,
        dimension6: accountingDimensions?.dimension6,
        GLFieldName: accountingDimensionsFieldName?.GLFieldName,
        Dimension2FieldName: accountingDimensionsFieldName.Dimension2FieldName,
        Dimension3FieldName: accountingDimensionsFieldName.Dimension3FieldName,
        Dimension4FieldName: accountingDimensionsFieldName.Dimension4FieldName,
        Dimension5FieldName: accountingDimensionsFieldName.Dimension5FieldName,
        Dimension6FieldName: accountingDimensionsFieldName.Dimension6FieldName

        // id:1 
      };
      addEditAccountDimension(data, (res => {

        toast.success(res.message);
      }))
      navigate('/accounting-dimension-list')
    } catch (error) {
    //  console.log(error)
    }
  }



  return (
    <div className='container-fluid'>
      <div className='dbMain accountDimenbg'>
        <Leftpanel />
        <div className='dbRight'>
          <Header link="/dashboard" title="Configuration > Others > Accounting Dimensions" description="" />
          <div className='commonBase'>
            <form>
              <div className='row'>
                <div className='col-md-12 mb-3'>
                  <label htmlFor="AccountingDimensions">Accounting Dimensions</label>
                  <select className='form-control' id='AccountingDimensions' name="businessunit" onChange={e => _UPDATE_DIMANTION(e.target.value)}>
                    {/* <option value="" >Select Accounting Dimensions</option> */}
                    <option value={2} >2</option>
                    <option value={3} >3</option>
                    <option value={4} >4</option>
                    <option value={5} >5</option>
                    <option value={6} >6</option>
                  </select>
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12 mb-3'>
                  <label htmlFor="glKey">GL Key</label>
                  <input className='form-control' type="text" name="" id="glKey" placeholder='GL Key Field Name' onChange={e => setAccountingDimensionsFieldName({ ...accountingDimensionsFieldName, GLFieldName: e.target.value })} /><br />
                  <input className='form-control' type="text" name="" id="glKey" placeholder='GL Key' value={glKey?.text} disabled />
                </div>
              </div>

              {/* {
                accountingDimensions.length>0 &&
                accountingDimensions.map((item,index)=>{return(
                  <div className='row'>
                  <div className='col-md-12 mb-3'>
                    <label htmlFor="glKey">Dimensions {index+2} </label>
                    <input className='form-control' type="text" name="" id="glKey" placeholder={`Dimensions ${index+2}`}  onChange={e=>_SET_ACCOUTING_DIMANTION(e,index)} />
                  </div>
                </div>
                )})
              } */}

              {
                totalDimantion >= 2 &&
                <div className='row'>
                  <div className='col-md-12 mb-3'>
                    <label htmlFor="glKey">Dimensions 2 </label>
                    <input className='form-control' type="text" name="" id="glKey" placeholder='GL Key Field Name' onChange={e => setAccountingDimensionsFieldName({ ...accountingDimensionsFieldName, Dimension2FieldName: e.target.value })} /><br />
                    <input className='form-control' type="text" name="" id="glKey" placeholder={`Dimensions 2`} value={accountingDimensions.dimension2} onChange={e => setAccountingDimensions({ ...accountingDimensions, dimension2: e.target.value })} />
                  </div>
                </div>
              }
              {
                totalDimantion >= 3 &&
                <div className='row'>
                  <div className='col-md-12 mb-3'>
                    <label htmlFor="glKey">Dimensions 3 </label>
                    <input className='form-control' type="text" name="" id="glKey" placeholder='GL Key Field Name' onChange={e => setAccountingDimensionsFieldName({ ...accountingDimensionsFieldName, Dimension3FieldName: e.target.value })} /><br />
                    <input className='form-control' type="text" name="" id="glKey" placeholder={`Dimensions 3`} value={accountingDimensions.dimension3} onChange={e => setAccountingDimensions({ ...accountingDimensions, dimension3: e.target.value })} />
                  </div>
                </div>
              }
              {
                totalDimantion >= 4 &&
                <div className='row'>
                  <div className='col-md-12 mb-3'>
                    <label htmlFor="glKey">Dimensions 4 </label>
                    <input className='form-control' type="text" name="" id="glKey" placeholder='GL Key Field Name' onChange={e => setAccountingDimensionsFieldName({ ...accountingDimensionsFieldName, Dimension4FieldName: e.target.value })} /><br />
                    <input className='form-control' type="text" name="" id="glKey" placeholder={`Dimensions 4`} value={accountingDimensions.dimension4} onChange={e => setAccountingDimensions({ ...accountingDimensions, dimension4: e.target.value })} />
                  </div>
                </div>
              }
              {
                totalDimantion >= 5 &&
                <div className='row'>
                  <div className='col-md-12 mb-3'>
                    <label htmlFor="glKey">Dimensions 5 </label>
                    <input className='form-control' type="text" name="" id="glKey" placeholder='GL Key Field Name' onChange={e => setAccountingDimensionsFieldName({ ...accountingDimensionsFieldName, Dimension5FieldName: e.target.value })} /><br />
                    <input className='form-control' type="text" name="" id="glKey" placeholder={`Dimensions 5`} value={accountingDimensions.dimension5} onChange={e => setAccountingDimensions({ ...accountingDimensions, dimension5: e.target.value })} />
                  </div>
                </div>
              }
              {
                totalDimantion >= 6 &&
                <div className='row'>
                  <div className='col-md-12 mb-3'>
                    <label htmlFor="glKey">Dimensions 6 </label>
                    <input className='form-control' type="text" name="" id="glKey" placeholder='GL Key Field Name' onChange={e => setAccountingDimensionsFieldName({ ...accountingDimensionsFieldName, Dimension6FieldName: e.target.value })} /><br />
                    <input className='form-control' type="text" name="" id="glKey" placeholder={`Dimensions 6`} value={accountingDimensions.dimension6} onChange={e => setAccountingDimensions({ ...accountingDimensions, dimension6: e.target.value })} />
                  </div>
                </div>
              }
              {!glKey && <p className='text-center text-danger'>Please Update GL Key</p>}
              <button className='commonButton' onClick={_ADD_GL_KEY}>Save</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AccountingDimensions